import React, { useEffect, useState } from 'react';

import styled from 'styled-components';
import { ForecastPayload } from '../../../../api/report/type';
import { H3, P1 } from '../../../Atoms/Typo';
import Title from '../../../Molecule/Card/CardTitle/ReportTitle';
import MultiLineChart from '../../../Molecule/Chart/MultiLineChart';
import Count from '../../../Molecule/Count/NumberToKorean';
import Spinner from '../../../Molecule/Spinner';

const Component = styled.div`
  width: 100%;
  height: 497px;
  display: flex;
  background-color: white;
  border: solid 1px ${(props) => props.theme.colors.grey200};
  border-radius: 8px;
`;

const ReportSummaryWrapper = styled.div`
  display: flex;
  width: 100%;
  margin-top: 24px;
  ${P1};

  em {
    font-style: normal;
    ${H3};
    .voda_num_to_kor_count {
      ${H3};
    }
  }
`;

const Split = styled.div`
  height: 100%;
  width: 1px;
  background-color: ${(props) => props.theme.colors.grey200};
`;

const InnerComponent = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 100%;
  padding: 24px 24px 40px 24px;
`;

const Body = styled.div`
  width: 100%;
  flex: 1;
  margin-top: 40px;
`;

interface ForecastReportCardProps {
  uvData: ForecastPayload | null;
  pvData: ForecastPayload | null;
  isLoading: boolean;
}

const ForecastReportCard = ({
  uvData,
  pvData,
  isLoading,
}: ForecastReportCardProps) => {
  const [uvTotal, setUVTotal] = useState(0);
  const [pvTotal, setPVTotal] = useState(0);

  useEffect(() => {
    if (uvData) {
      setUVTotal(uvData.pre_total);
    }
  }, [uvData]);

  useEffect(() => {
    if (pvData) {
      setPVTotal(pvData.pre_total);
    }
  }, [pvData]);
  return (
    <Component>
      <InnerComponent>
        <Title title="이번 달 사용자 수는?" />
        <ReportSummaryWrapper>
          이번 달은&nbsp;
          <em>약</em>&nbsp;
          <em>
            <Count value={uvTotal} />
          </em>
          <em>명</em>이 방문할 것으로 예상됩니다.
        </ReportSummaryWrapper>
        <Body>
          {isLoading ? (
            <Spinner />
          ) : (
            <MultiLineChart
              selectedTimeSort="day"
              lineLabel="사용자 수"
              isReport
              Data={uvData?.pre_date_cnt || null}
            />
          )}
        </Body>
      </InnerComponent>
      <Split />
      <InnerComponent>
        <Title title="이번 달 페이지 뷰 수는?" />
        <ReportSummaryWrapper>
          이번 달은&nbsp;
          <em>약</em>&nbsp;
          <em>
            <Count value={pvTotal} />
          </em>
          <em>개</em>&nbsp; 페이지를 이용할 것으로 예상됩니다.
        </ReportSummaryWrapper>
        <Body>
          {isLoading ? (
            <Spinner />
          ) : (
            <MultiLineChart
              selectedTimeSort="day"
              lineLabel="페이지 뷰 수"
              isReport
              Data={pvData?.pre_date_cnt || null}
            />
          )}
        </Body>
      </InnerComponent>
    </Component>
  );
};

export default ForecastReportCard;
